import React, { useCallback, useEffect, useState } from "react";

import heroImgPlaceholder from "images/volunteer/hero-img.png";

import FocusArticles from "../../components/program-focus/focusArticles";
import FocusGviExperiences from "../../components/program-focus/focusGviExperiences";
import Hero from "../../components/shared/hero";
import TwoColumnHero from "../../components/shared/heros/twoColumnHero";
import LongFocusLocationOverview from "../../components/shared/twoColumn/longFocusLocationOverview";
import LongFocusLocationPrograms from "../../components/shared/twoColumn/longFocusLocationPrograms";
import LocationFilter from "../shared/filters/locationFilter";
import ProductTypeFilter from "../shared/filters/productTypeFilter";
import GridGallery from "../shared/gallery/gridGallery";

const TwoColumnLocationPageComponent = ({
  page,
  groupProgramSourceType,
  getFilterByProgramType,
  getFilterByProgramExtraTypes,
  getFilterByLocation,
  getFilterByProgramFocus,
  programListFilterStrict = false,
  isMobile = false,
  layout = "location"
}) => {
  const [triggerTypeFilter, setTriggerTypeFilter] = useState(
    getFilterByProgramType || []
  );
  const [triggerLocationFilter, setTriggerLocationFilter] = useState(
    getFilterByLocation || []
  );

  const [locationFilterCounter, setLocationFilterCounter] = useState([]);

  const [typeFilterCounter, setTypeFilterCounter] = useState([]);

  const headTitle = page.title ?? "";
  const acfFields = page?.acfLandingPage ?? {};

  const heroBackgroundImage =
    page.globalConfig &&
    page.globalConfig.backgroundImage &&
    page.globalConfig.backgroundImage.localFile &&
    page.globalConfig.backgroundImage.localFile.extension
      ? page.globalConfig.backgroundImage.localFile.publicURL
      : page.globalConfig &&
          page.globalConfig.backgroundImage &&
          page.globalConfig.backgroundImage.sourceUrl
        ? page.globalConfig.backgroundImage.sourceUrl
        : heroImgPlaceholder;

  const heroBackgroundVideo =
    page.globalConfig && page.globalConfig.backgroundVideoJw
      ? page.globalConfig.backgroundVideoJw
      : "";

  const heroClassName = "w-full h-full flex-col sm:hero-section";

  const programListSectionTitle =
    acfFields?.genProgramListSectionTitle ?? acfFields?.genProgramSectionTitle;
  const headSubtitle =
    acfFields && acfFields?.genSubtitle
      ? acfFields.genSubtitle
      : "Promoting ecosystems and wildlife to thrive for generations.";
  const secondayHeadline =
    acfFields && acfFields?.genSecondaryHeadline
      ? acfFields.genSecondaryHeadline
      : "";

  const imageGallery =
    (acfFields?.genFeaturedGallery &&
      acfFields.genFeaturedGallery.map((imgItem) => ({
        ...imgItem,
        type: "image"
      }))) ??
    [];

  const tabDetails = acfFields?.genContentTabs ?? [];

  const programFeaturedVideo = "";
  const genFeaturedVideos = acfFields?.genFeaturedVideos ?? [];
  const programUri = "";
  const gotoViewText = "See gallery";
  const locationSummary = page.content ?? "";

  const focusBlogPosts =
    page?.acfLandingPage?.genBlogFocus?.flatMap(
      (focus) => focus?.posts?.nodes
    ) ?? [];

  const focusList =
    page?.acfLandingPage?.genProgramFocus?.flatMap((focus) => focus) ?? [];

  const locations = page?.acfLandingPage?.genProgramLocation?.flatMap(
    (location) => {
      return {
        text: location?.name,
        slug: location?.slug,
        link:
          location?.geographicalTaxonomy?.pageLink?.uri ??
          location?.locationPages?.nodes
            ?.flatMap((locPage) => locPage.uri)
            .shift() ??
          "#"
      };
    }
  );

  const headerIcons = (acfFields && acfFields?.genHeaderIcons) ?? [];
  const heroNavLinks = headerIcons?.map((icon, idx) => {
    return {
      imgPath: "location-icon.svg",
      toPage: "#",
      text: `Something something-${idx}`
    };
  });

  const scrollToPrograms = () => {
    const programList = document.querySelector("#view-programs");
    programList?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  useEffect(() => {
    const nav = document.querySelector("#mobile-program-cta");
    let lastScrollY = window.scrollY;

    window.addEventListener("scroll", () => {
      if (lastScrollY < window.scrollY) {
        nav.classList.add("!hidden");
      } else {
        nav.classList.remove("!hidden");
      }

      lastScrollY = window.scrollY;
    });
  }, []);

  const getExperienceLocationPages =
    acfFields?.genProgramLocation?.flatMap(
      (loc) => loc?.locationPages?.nodes
    ) ?? [];

  const locationPageFilterSlugs =
    getExperienceLocationPages?.map((loc) => loc.slug) ?? [];

  const experiencesDetails =
    page?.genericDetails?.countryExploration &&
    page?.genericDetails?.countryExploration?.acfCountryExploration
      ? page?.genericDetails?.countryExploration?.acfCountryExploration
      : "";

  const overviewTitle =
    layout === "location"
      ? `Programs in ${headTitle}`
      : `${headTitle} projects` ?? "";

  const renderProgramList = (
    <LongFocusLocationPrograms
      focusList={focusList}
      groupProgramSourceType={groupProgramSourceType}
      getFilterByProgramType={triggerTypeFilter}
      getFilterByProgramExtraTypes={getFilterByProgramExtraTypes}
      getFilterByLocation={triggerLocationFilter}
      getFilterByProgramFocus={getFilterByProgramFocus}
      programListSectionTitle={programListSectionTitle}
      headTitle={headTitle}
      headSubtitle={headSubtitle}
      programFeaturedVideo={programFeaturedVideo}
      programUri={programUri}
      gallery={imageGallery}
      baseLocations={locations}
      gotoViewText={gotoViewText}
      locationSummary={locationSummary}
      isProgramFocusPage={true}
      genFeaturedVideos={genFeaturedVideos}
      locationTitle={overviewTitle}
      setFilterByProgramType={setTypeFilterCounter}
      setFilterByProgramLocation={setLocationFilterCounter}
    />
  );

  const initTriggerTypeFilter = useCallback((item) => {
    if (item) {
      let newlist = [];

      if (item) {
        newlist?.push(item);
      }
      // if (getFilterByProgramType) {
      //   newlist?.push(getFilterByProgramType);
      // }

      setTriggerTypeFilter([...new Set(newlist?.flat()?.filter((el) => el))]);
    }
  }, []);

  const initTriggerLocationFilter = useCallback((item) => {
    if (item) {
      let newlist = [];

      if (item) {
        newlist?.push(item);
      }

      setTriggerLocationFilter([
        ...new Set(newlist?.flat()?.filter((el) => el))
      ]);
    }
  }, []);

  return (
    <>
      <div className="relative">
        <div className="block sm:hidden">
          <Hero
            heroHeadLine={""}
            heroImg={heroBackgroundImage}
            navLinks={heroNavLinks ?? ""}
            videoId={""}
            heroClass={heroClassName}
            gallery={imageGallery}
            featuredVideoGallery={genFeaturedVideos}
            layout={"h-gal"}
          />
        </div>
        <TwoColumnHero
          headTitle={headTitle}
          headSubtitle={headSubtitle}
          programFeaturedVideo={programFeaturedVideo}
          programUri={programUri}
          gallery={imageGallery}
          baseLocations={locations}
          gotoViewText={gotoViewText}
          locationSummary={locationSummary}
          isProgramFocusPage={true}
          genFeaturedVideos={genFeaturedVideos}
          heroBackgroundImage={heroBackgroundImage}
          sectionContainerStyles={`px-4 sm:px-0 py-6 sm:py-0 ${
            layout === "location"
              ? "sm:h-112 overflow-hidden"
              : "sm:h-101 overflow-hidden"
          }`}
          pageType={layout}
          setTriggerTypeFilter={initTriggerTypeFilter}
          selectedTypeFilter={triggerTypeFilter}
          programTypeFilterCounter={typeFilterCounter}
        />
      </div>
      <div
        className={`container justify-center items-center mx-auto sm:w-5/6 sm:z-10 bg-white planet:gvi-dark-gray-bg px-4 sm:px-0 ${layout === "location" ? "sm:-mt-44" : "sm:-mt-10"}`}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2">
          <>
            <div className={`flex flex-col flex-wrap sm:z-20`}>
              {secondayHeadline && (
                <div
                  className="text-title sm:text-xlrg font-normal planet:font-light text-section-title-text planet:text-white font-alice planet:font-body py-4 sm:py-5 px-4 sm:px-0 sm:h-24 sm:leading-10"
                  dangerouslySetInnerHTML={{
                    __html: secondayHeadline
                  }}
                />
              )}

              {tabDetails &&
                tabDetails.length &&
                tabDetails?.map((detail, i) => {
                  const count = 0;

                  return (
                    <React.Fragment key={i}>
                      <div className="w-full sm:w-5/6">
                        <LongFocusLocationOverview
                          key={i}
                          title={detail?.genTabTitle}
                          text={detail?.tabContentDesc}
                        />
                      </div>

                      {count === i ? (
                        <>
                          <GridGallery
                            gallery={imageGallery}
                            videoGallery={genFeaturedVideos}
                            featuredSingleVideo={programFeaturedVideo}
                            containerClass="relative w-full sm:w-5/6 pt-8 pb-20 gallery-wrapper hidden sm:block"
                          />
                          <div
                            className="w-full block sm:hidden py-2 sm:py-6"
                            id={"view-programs"}
                          >
                            <div className="divide-y width-divider block sm:hidden mb-6" />

                            <div className="flex flex-col flex-wrap w-full sm:py-16">
                              <h1
                                className={`font-normal planet:font-light font-alice planet:font-body sm:pb-6 leading-10 ${layout === "location" || layout === "focus" ? "" : "pb-6 pl-6"}`}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    layout === "location" || layout === "focus"
                                      ? "Filter programs"
                                      : "Our programs"
                                }}
                              />
                              {layout === "location" && (
                                <div className="">
                                  <ProductTypeFilter
                                    setFilterOption={setTriggerTypeFilter}
                                    selectedType={triggerTypeFilter}
                                    programCounter={typeFilterCounter}
                                  />
                                </div>
                              )}
                              {layout === "focus" && (
                                <LocationFilter
                                  setFilterOption={initTriggerLocationFilter}
                                  selectedType={triggerLocationFilter}
                                  programCounter={locationFilterCounter}
                                  locationList={Object.keys(
                                    locationFilterCounter
                                  )}
                                />
                              )}
                            </div>

                            {renderProgramList}
                            <div className="divide-y width-divider block sm:hidden mb-6" />
                            {locationPageFilterSlugs?.length > 0 && (
                              <>
                                <FocusGviExperiences
                                  locationPageSlugs={locationPageFilterSlugs}
                                  experiencesDetails={experiencesDetails}
                                  activitiesClass="planet:bg-gray-dark"
                                />
                                <div className="divide-y width-divider block sm:hidden mb-6" />
                              </>
                            )}
                          </div>
                        </>
                      ) : null}
                    </React.Fragment>
                  );
                })}
            </div>

            <div
              className={`hidden sm:block flex-col sm:pb-8 ${layout === "location" ? "sm:mt-16 planet:sm:mt-3" : " sm:mt-16"}`}
            >
              {layout === "focus" && (
                <div className="flex flex-col flex-wrap w-full sm:pb-8">
                  <h1
                    className={`font-normal planet:font-light font-alice planet:font-body sm:pb-6 leading-10 ${layout === "focus" ? "" : "pb-6 pl-6"}`}
                    dangerouslySetInnerHTML={{
                      __html: "Filter programs"
                    }}
                  />
                  <div className="">
                    <LocationFilter
                      setFilterOption={initTriggerLocationFilter}
                      selectedType={triggerLocationFilter}
                      programCounter={locationFilterCounter}
                      locationList={Object.keys(locationFilterCounter)}
                    />
                  </div>
                </div>
              )}

              {renderProgramList}
            </div>
          </>
        </div>
      </div>

      <div
        className="flex w-2/3 view-programs-link pt-8 justify-center items-center mx-auto fixed inset-x-0 bottom-28 place-items-center z-30 px-5 py-3"
        id={"mobile-program-cta"}
      >
        <button
          className={`view-program-link group flex w-full justify-center items-center gap-2 py-2 text-base planet:text-sm font-semibold px-7 rounded-full border border-black-lighter planet:border-white text-black-lighter planet:text-white bg-white planet:bg-gray-darker ${
            !isMobile ? "block sm:hidden" : ""
          }`}
          onClick={scrollToPrograms}
        >
          <span>View programs</span>
        </button>
      </div>
      <div className="hidden sm:block">
        <FocusGviExperiences
          locationPageSlugs={locationPageFilterSlugs}
          experiencesDetails={experiencesDetails}
        />
      </div>
      <FocusArticles blogPosts={focusBlogPosts} />
    </>
  );
};

export default TwoColumnLocationPageComponent;
